import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import { useDeliveryModel } from '../useDeliveryModel'
import { useFeatureFlags } from '../useFeatureFlags'

/** Appointment Guides are for Teleaudiology only: the flag must be on and Teleaudiology selected in the header toggle */
const useIsAppointmentGuidesEnabled = () => {
  const [isFlagEnabled] = useFeatureFlags(['APPOINTMENT_GUIDES'])
  const { deliveryModel } = useDeliveryModel()

  return Boolean(isFlagEnabled) && deliveryModel === DeliveryModel.TELEAUDIOLOGY
}

export { useIsAppointmentGuidesEnabled }
